import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import {AuthComponent} from './layout/auth/auth.component';
import { AuthGuard } from './shared/auth/auth.guard';

const routes: Routes = [

  {
    path: '',
    component: AuthComponent,

    children: [
       {
        path: '',
        redirectTo: 'auth/login/simple',
        pathMatch: 'full',
      },

      {
        path: 'auth',
        loadChildren: './theme/auth/auth.module#AuthModule'
      }
    ]
  },



  {
    path: '',
    component: AdminComponent,
    children: [

      // {
      //   path: '',
      //   redirectTo: 'dashboard/default',
      //   pathMatch: 'full',
      //   canActivate: [AuthGuard]
      // },
      // {
      //   path: 'dashboard',
      //   loadChildren: './theme/dashboard/dashboard.module#DashboardModule',
      //   canActivate: [AuthGuard]
      // },
      {
        path: 'actiontracker',
        loadChildren: './component/action-tracker/action-tracker.module#ActionTrackerModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'rfq',
        loadChildren: './component/rfq/rfq.module#RfqModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'buyer',
        loadChildren: './component/buyer/buyer.module#BuyerModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'manufacturer',
        loadChildren: './component/manufacturer/manufacturer.module#ManufacturerModule',
        canActivate: [AuthGuard]
      },
      // {
      //   path: 'dashboard',
      //   loadChildren: './theme/dashboard/default/default.module#DefaultModule',
      //   canActivate: [AuthGuard]
      // },
      {
        path: 'messages',
        loadChildren: './component/global-message-tab/global-message-tab.module#GlobalMessageTabModule',
        canActivate: [AuthGuard]
      },
      {
        path: 'user-management',
        loadChildren: './component/user-management/user-management.module#UserManagementModule',
        canActivate: [AuthGuard]
      },

    ]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts